/** Convert CSS color property to rgba array */
export const stringToColor = (cssColor) => {
    const el = document.createElement("div");
    el.style.color = cssColor;
    if (el.style.color !== "") {
        document.body.appendChild(el);
        const colorStr = window.getComputedStyle(el).color;
        document.body.removeChild(el);
        const colorStrArr = colorStr.replace(/[^\d,]/g, "").split(",");
        const color = colorStrArr.map((str) => parseInt(str));
        if (color.length === 3) {
            color.push(1);
        }
        return color;
    }
};
/** Convert rgb Array CSS hex string */
export const rgbToHex = (rgb) => {
    if (!(rgb instanceof Array) || rgb.length < 3) {
        return;
    }
    const numberToHex = function (num) {
        let hex = Number(num).toString(16);
        if (hex.length < 2) {
            hex = "0" + hex;
        }
        return hex;
    };
    const r = numberToHex(rgb[0]);
    const g = numberToHex(rgb[1]);
    const b = numberToHex(rgb[2]);
    return "#" + r + g + b;
};
//# sourceMappingURL=Color.js.map